import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageLoadSpinner from 'bento-ordering/base/ui_components/PageLoadSpinner';
import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';
import { setupInitialFlow } from 'bento-ordering/base/actions/setupInitialFlow';

const SetupInitialFlow = ({ children, dispatch }) => {
  const [readyToRender, setReadyToRender] = useState(false);

  useEffect(() => {
    const asyncFn = async () => {
      await dispatch(setupInitialFlow({}));
      setReadyToRender(true);
    };

    asyncFn();
  }, []);
  return readyToRender ? children : <PageLoadSpinner />;
};

SetupInitialFlow.propTypes = {
  children: CHILDREN_PROPTYPES,
  dispatch: PropTypes.func.isRequired
};

export default connect()(SetupInitialFlow);
